module.exports = __webpack_public_path__ + "img/muffin-2.1d584b46.svg";